var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.698925 0C1.08493 0 1.39785 0.356345 1.39785 0.795918V11.2041C1.39785 11.6437 1.08493 12 0.698925 12C0.312919 12 0 11.6437 0 11.2041V0.795918C0 0.356345 0.312919 0 0.698925 0ZM5.00019 0C5.3862 0 5.69912 0.356345 5.69912 0.795918V11.2041C5.69912 11.6437 5.3862 12 5.00019 12C4.61419 12 4.30127 11.6437 4.30127 11.2041V0.795918C4.30127 0.356345 4.61419 0 5.00019 0ZM10 0.795918C10 0.356345 9.68708 0 9.30107 0C8.91507 0 8.60215 0.356345 8.60215 0.795918V11.2041C8.60215 11.6437 8.91507 12 9.30107 12C9.68708 12 10 11.6437 10 11.2041V0.795918Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesOutlined);
export default __webpack_public_path__ + "static/media/linesOutlined.81d3a8d0fc564f4764b5df0971cefadb.svg";
export { ForwardRef as ReactComponent };